import { taskDueParts } from "@/lib/taskDue";

// Optional time input that unlocks once a due date is picked.
export const TaskTimeInput = ({ date, value, onChange, testid = "task-due-time" }) => (
  <div>
    <input
      type="time"
      className="input"
      value={date ? value : ""}
      disabled={!date}
      title={date ? "" : "Pick a date first"}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      style={{ width: "100%", opacity: date ? 1 : 0.5, cursor: date ? "text" : "not-allowed" }}
    />
    <div data-testid={`${testid}-help`} style={{ fontSize: 10, color: "var(--text-tertiary, #94a3b8)", marginTop: 3 }}>
      Leave blank to follow up anytime on this date
    </div>
  </div>
);

// "Jan 15, 2025 at 2:30 PM" / "Jan 15, 2025 (Anytime)" / "No date".
export const TaskDueText = ({ task, overdue = false, testid }) => {
  const p = taskDueParts(task);
  if (!p) return <span data-testid={testid}>No date</span>;
  return (
    <span data-testid={testid}>
      {p.day}
      {p.time
        ? <>
            {" at "}<span style={{ color: overdue ? "inherit" : "var(--text-primary, var(--text, #0f172a))" }}>{p.time}{p.tz ? ` ${p.tz}` : ""}</span>
            {p.leadTime && <span data-testid={testid ? `${testid}-lead` : undefined} style={{ opacity: 0.75 }}> (lead {p.leadTime})</span>}
          </>
        : <span style={{ opacity: 0.75 }}> (Anytime)</span>}
    </span>
  );
};
